import React from 'react';
import { createRoot } from 'react-dom/client';
import { CaseCardSlider, CaseCardType } from '@othram/helix';

// Removed: declare global { interface Window { OTHRAM_API_URL?: string; SOLVE_PATH?: string; } }
// No longer needed - now using data attributes instead of window globals

const fetchCaseCards = async (OTHRAM_API_URL: string): Promise<CaseCardType[]> => {
    if (!OTHRAM_API_URL.endsWith("/")) OTHRAM_API_URL += "/";
    let response = await fetch(`${OTHRAM_API_URL}case_cards`);
    if (!response.ok) throw new Error("Failed to fetch case cards");

    let responseJson = await response.json();
    let caseCards = responseJson.case_cards.map((card: any) => {
        const leaderText = card.text.split('\n')[0] || '';
        const bodyText = card.text.split('\n')[1] || '';
        return {
            slug: card.slug,
            agencyName: card.agency_name,
            leaderText: leaderText,
            bodyText: bodyText,
            imageUrl: card.image_url,
            url: card.url
        }

    });
    return caseCards as CaseCardType[];
}

// Mount the CaseCardSlider component when the DOM is loaded
document.addEventListener('DOMContentLoaded', async () => {
    const container = document.getElementById('case-cards-section');
    let caseCards: CaseCardType[] = [];

    // Changed from window.OTHRAM_API_URL global to data attribute for cleaner scope
    // Updated alongside research section for consistency (ES module migration)
    // Template provides: <div id="case-cards-section" data-api-url="{{ othram_api_url }}">
    const apiUrl = container?.dataset.apiUrl;
    if (apiUrl) {
        try {
            caseCards = await fetchCaseCards(apiUrl);
        } catch (error) {
            console.error("Error fetching case cards:", error);
        }
    }

    if (container) {
        // Allow customizing title via data-title attribute (defaults to "Recent Casework")
        // Template can provide: data-title="Solved<br>by DNA." for custom titles
        const titleHtml = container.dataset.title || 'Recent<br />Casework';

        const root = createRoot(container);
        root.render(<CaseCardSlider
            titleText={<span dangerouslySetInnerHTML={{ __html: titleHtml }} />}
            caseCards={caseCards}
            full={false}
            limit={7}
            seeMoreLink='recent_casework.html'
            solveCaseLink={container.dataset.solvePath || 'solve.html'}
        />);
    }
});
